<div>
  <span [title]="title" class="sec-title">
    {{ title?.length > 50 ? (title | slice:0:50) + '...' : title }}
  </span>
  @if (dataCount) {
    <span class="count-icon font-s">{{dataCount}}</span>
  }
  @if (count) {
    <span style="margin-left: 16px;"></span>
  }
  @if (count) {
    <span [id]="countId" class="count-icon">{{count}}</span>
  }
</div>